module.exports = __webpack_public_path__ + "static/img/male-3.37b6c275.webp";